import { render, staticRenderFns } from "./LogoRadar.vue?vue&type=template&id=506af8b1&"
import script from "./LogoRadar.vue?vue&type=script&lang=js&"
export * from "./LogoRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports